import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import styles from './Header.module.css';
import { HiMenu, HiX } from 'react-icons/hi'; // Add icon library for hamburger and close icons
import { getHeaderRes } from "../../loaders/header";

const Header = () => {
  const [data, setData] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage menu visibility
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getHeaderRes('/header', [], []);
        setData(data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev); // Toggle menu visibility
  };

  if (!data?.logo) return null;

  return (
    <div className={`${styles.headerContent} header`}>
      <Link to={data?.logo?.link?.href}>
        <img
          loading="lazy"
          src={data?.logo?.logo?.url}
          className={styles.logo}
          alt="Company logo"
        />
      </Link>
      <div className={styles.hamburger} onClick={toggleMenu}>
        {isMenuOpen ? <HiX size={30} /> : <HiMenu size={30} />} {/* Hamburger icon or close icon */}
      </div>
      <nav className={`${styles.nav} ${isMenuOpen ? styles.active : ''}`}> {/* Add active class if menu is open */}
        {data?.navigation_menu?.map((item, index) => (
          <a key={index} href={item?.link?.href} target={item?.link?.href.includes('.') ? '_blank' : '_self'} className={styles.navItem} >
            {item.link.title}
          </a>
        ))}
      </nav>
    </div>
  );
};

export default Header;